import styled from "@emotion/styled";

import logoAvanti from "../../assets/avantiicon.png";
import LoginAvantiFormPopup from "./LoginAvantiPopup";

const LoginAvantiButton = (props) => {
  const { className, popup } = props;

  const open = () => {
    popup.setIsOpen(true);
    popup.setContent(<LoginAvantiFormPopup {...props} />);
  };

  return (
    <StyledAvantiLoginButton onClick={open} className={className}>
      <div className="icon-container">
        <img src={logoAvanti} className="avanti-icon" alt="logoavanti" />
      </div>
      <div className="txt-container">
        <span className="social-txt">Login com Avanti</span>
      </div>
      <div className="icon-container"></div>
    </StyledAvantiLoginButton>
  );
};

export default LoginAvantiButton;

const StyledAvantiLoginButton = styled.a`
  cursor: pointer;

  .avanti-icon {
    width: 70px;
    height: 24px;
  }
`;
